module.exports = __webpack_public_path__ + "static/media/ow2ll11.3ce640c8.png";